/**
 * 模块 - 设备管理 - 英文
 */
export default {
  equipment: {
    // Page names
    studyMachine: 'Study Machine',
    deliveryCreation: 'Delivery Creation',
    deliveryDetail: 'Delivery Detail',
    childrenDevice: 'Children Device',
    barterManage: 'Barter Manage',
    takeDelivery: 'Take Delivery',
    prototypeManagement: 'Prototype Management',

    // Common
    deviceSN: 'Device SN',
    deviceName: 'Device Name',
    agent: 'Agent',
    status: 'Status',
    createTime: 'Create Time',
    creator: 'Creator',
    operation: 'Operation',
    detail: 'Detail',
    cancel: 'Cancel',
    confirm: 'Confirm',
    remark: 'Remark',
    yes: 'Yes',
    no: 'No',
    latest: 'Latest',

    // studyMachine
    assignDistributor: 'Assign Distributor',
    assignCounter: 'Assign Counter',
    batchModifyAgent: 'Batch Modify Agent',
    modifyAgent: 'Modify Agent',
    changeBindPhone: 'Change Bind Phone',
    phoneRebind: 'Change Bind Phone',
    logisticsDetail: 'Logistics Detail',
    companyName: 'Company Name',
    pleaseSelectCompany: 'Select company',
    expressNo: 'Express No.',
    query: 'Query',
    studyMachineRemark: 'Study Machine Remark',
    machineAccountCode: 'Machine Account Code',
    machineAccount: 'Machine Account',
    originalAgentId: 'Original Agent ID',
    originalAgentName: 'Original Agent Name',
    newAgentId: 'New Agent ID',
    newAgentName: 'New Agent Name',
    purchaseOrder: 'Purchase Order',
    purchaseOrderNo: 'Purchase Order',
    pleaseFillPurchaseOrderNo: 'Enter purchase order',
    migrateAccount: 'Move Account',
    pleaseFillNewAgentId: 'Enter new agent ID',
    pleaseFillPurchaseOrder: 'Enter purchase order',
    pleaseSelect: 'Please select',
    isMoveAccount: 'Move Account',
    batchAssignDistributor: 'Batch Assign Distributor',
    assignTo: 'Assign to:',
    pleaseSelectDistributor: 'Select distributor',
    assignToCounter: 'Assign to:',
    pleaseSelectCounter: 'Select counter',
    pleaseSelectMachine: 'Please select study machine',
    agentIdSameTip: 'New and old agent ID cannot be the same',
    sendCode: 'Send Code',
    resend: 'Resend',
    resendCode: 'Resend',
    secondsResend: 'Resend in {n}s',
    verificationCode: 'Verification Code',
    originalPhone: 'Original Phone',
    pleaseFillOriginalPhone: 'Enter original phone',
    pleaseFillNewPhone: 'Enter new phone',
    verifyCode: 'Verify Code',
    pleaseFillVerifyCode: 'Enter verify code',
    pleaseFillVerificationCode: 'Enter verify code',
    nextStep: 'Next',
    bindSuccess: 'Bind changed successfully',
    bindFail: 'Bind change failed',
    assignSuccess: 'Assigned successfully',
    assignFail: 'Assign failed',
    modifySuccess: 'Modified successfully',
    modifyFail: 'Modify failed',
    cancelSuccess: 'Cancelled successfully',
    cancelFail: 'Cancel failed',
    verifySuccess: 'Verification code sent',
    verifyFail: 'Verification code send failed',
    submitFail: 'Submit failed',
    pleaseSelectPerson: 'Select person to assign',
    accountPhoneRebind: 'Account Phone Rebind',

    // TakeDelivery
    newLading: 'New Lading',
    prepayFreight: 'Prepay Freight',
    cancelShipment: 'Cancel Shipment',
    confirmCancelShipment: 'Confirm to cancel lading?',
    ladingNo: 'Lading No.',
    productName: 'Product Name',
    warehouse: 'Warehouse',
    warehouseOrderNo: 'Warehouse Order No.',
    submitTime: 'Submit Time',
    sendStatus: 'Send Status',
    prepaidFreight: 'Prepaid Freight',
    extractNum: 'Extract Qty',
    sendNum: 'Send Qty',
    pleaseEnterLadingNo: 'Enter lading no.',
    pleaseSelectProductType: 'Select product type',
    pleaseSelectWarehouse: 'Select warehouse',
    pleaseSelectSendStatus: 'Select send status',
    pleaseEnterWarehouseOrderNo: 'Enter warehouse order no.',

    // ChildrenDevice
    addApply: '+ Add Apply',
    modify: 'Modify',
    audit: 'Audit',
    childDeviceExport: 'Child Device Export',
    applyNo: 'Apply No',
    agentId: 'Agent ID',
    agentName: 'Agent Name',
    teacherName: 'Teacher Name',
    teacherPhone: 'Teacher Phone',
    childName: 'Child Name',
    teacherCertNo: 'Teacher Cert No.',
    auditStatus: 'Status',
    createByName: 'Creator',
    auditTime: 'Audit Time',
    auditBy: 'Auditor',
    auditRemark: 'Audit Remark',
    regionAgentId: 'Region Agent ID',
    regionAgentName: 'Region Agent Name',
    orderNo: 'Order No',
    pleaseSelectAgent: 'Select agent',
    pleaseEnterApplyNo: 'Enter apply no.',
    pleaseEnterTeacherName: 'Enter teacher name',
    pleaseEnterTeacherPhone: 'Enter teacher phone',
    pleaseEnterTeacherCertNo: 'Enter teacher cert no.',
    pleaseSelectStatus: 'Select status',
    pleaseEnterOrderNo: 'Enter order no.',
    searchByDeviceSN: 'Search by device SN',
    deviceSNCol: 'Device SN',
    pendingAudit: 'Pending',
    auditPassed: 'Passed',
    auditRejected: 'Rejected',
    auditReject: 'Audit Reject',
    applyAgent: 'Apply Agent',
    regionAgent: 'Region Agent',
    applyRemarkLabel: 'Apply Remark',
    createTimeLabel: 'Create Time',
    teacherCertMaterial: 'Teacher Cert & Identity Materials',
    commitment: 'Commitment Letter',
    auditResult: 'Audit Result',
    pleaseEnterApplyRemark: 'Please fill in apply remark',
    pleaseEnterAuditRemark: 'Please fill in audit remark',
    pleaseSelectAuditResult: 'Please select audit result',
    clickUploadImage: 'Click to upload image',
    previewFile: 'Preview file',
    deleteFile: 'Delete file',
    pleaseUploadFile: 'Please upload file',
    pleaseEnterChildName: 'Enter child name',

    // DeviceManagement
    batchNo: 'Batch No.',
    pleaseEnterBatchNo: 'Enter batch no.',
    pleaseEnterDeviceSN: 'Enter device SN',
    pleaseEnterProductName: 'Enter product name',
    receiveInfo: 'Receive Info',
    pleaseEnterNamePhoneAddress: 'Enter name/phone/address',
    dispatchDate: 'Dispatch Date',
    expressCompany: 'Express Company',
    pleaseEnterExpressCompany: 'Enter express company',
    pleaseEnterExpressNo: 'Enter express no.',
    logisticsStatus: 'Logistics Status',
    pleaseSelectLogisticsStatus: 'Select logistics status',
    receiveBy: 'Receiver',
    receiveMobile: 'Receiver Phone',
    receiveAddress: 'Receiver Address',
    receiveAddressLabel: 'Receiver Address:',
    orderNo: 'Order No',
    productionNo: 'Batch No.',
    orderQuantityLabel: 'Order Qty:',
    deliveredQuantityLabel: 'Delivered Qty:',
    manufacturerLabel: 'Manufacturer:',
    provinceCityLabelShort: 'Province/City:',
    batchNoLabel: 'Batch No.:',
    snCodeLabel: 'SN Code:',
    deviceInfoLabel: 'Device Info:',
    pleaseSelectExpressCompany: 'Select express company',
    pleaseFillExpressNo: 'Enter tracking no.',
    pleaseFillBatchNo: 'Enter batch no.',
    pleaseFillSN: 'Enter SN code',
    pleaseSelectDeviceInfo: 'Select device info',

    // Manufacturer
    shipmentExport: 'Shipment Export',
    shipmentImport: 'Shipment Import',
    deliver: 'Deliver',
    batchImport: 'Batch Import',
    uploadDoc: 'Upload Doc',
    dataValidate: 'Data Validate',
    importData: 'Import Data',
    complete: 'Complete',
    step1Tip1: '1. Do not change header names and purchase order info in template',
    step1Tip2: '2. For multiple devices per order, copy purchase order info, one row per device',
    step1Tip3: '3. Purchase ID and order no. are unique identifiers',
    step1Tip4: '4. Import file should not exceed 1000 rows',
    step1Title: 'Select file and start import',
    dragOrClick: 'Drag file here or',
    clickUpload: 'click to upload',
    dataValidating: 'Validating data, please wait',
    dataRetrieved: 'Validation complete, total',
    orderInfo: 'order(s)',
    errorInfo: 'Error(s)',
    errorInfoTip: ', please correct and retry',
    errorFileDownload: 'Download file for error details',
    errorFileXls: 'Error Info.xls',
    importingData: 'Importing. You may close this page, import will continue.',
    importComplete: 'Import complete. Click to view',
    importDetail: 'Import Detail',
    purchaseNo: 'Purchase No.',
    pleaseEnterPurchaseNo: 'Enter purchase no.',
    orderStatus: 'Order Status',
    pleaseSelectOrderStatus: 'Select order status',
    orderTime: 'Order Time',
    lastDispatchTime: 'Last Dispatch Time',
    buyNum: 'Purchase Qty',
    receiveNum: 'Dispatch Qty',
    onlyXlsXlsx: 'Only .xls and .xlsx formats supported',
    upload: 'Upload',
    confirmImport: 'Confirm Import',
    done: 'Done',
    warningDataError: 'Warning: Data errors exist',
    partialErrorTip: 'Some data has errors. Errors will not be imported if you confirm.',
    noValidData: 'No valid data to import',
    saveSuccess: 'Saved successfully',
    saveFail: 'Save failed',
    confirmSuccess: 'Confirmed successfully',
    confirmFail: 'Confirm failed',
    campusId: 'Agent ID',
    purchaseId: 'Purchase ID',
    orderStatusName: 'Order Status',
    lastDispatchTimeLabel: 'Last Dispatch Time',
    receiver: 'Receiver',
    receiverPhone: 'Receiver Phone',
    receiverAddress: 'Receiver Address',
    manufacturer: 'Manufacturer',
    orderCreateTime: 'Order Time',

    // studyMachine config labels
    snCodeLabel: 'Device SN:',
    snCodePlaceholder: 'Enter device SN',
    productTypeLabel: 'Product Type',
    productTypePlaceholder: 'Select product type',
    agentLabel: 'Agent',
    agentPlaceholder: 'Select agent',
    accountStatusLabel: 'Account Status:',
    accountStatusPlaceholder: 'Select account status',
    notActivated: 'Not Activated',
    activated: 'Activated',
    frozen: 'Frozen',
    subscribed: 'Subscribed',
    activateDateLabel: 'Activate Date:',
    dispatchDateLabel: 'Dispatch Date:',
    expressCompanyLabel: 'Express Company:',
    expressCompanyPlaceholder: 'Select express company',
    expressNoLabel: 'Express No.:',
    expressNoPlaceholder: 'Select express no.',
    logisticsStatusLabel: 'Logistics Status:',
    logisticsStatusPlaceholder: 'Select logistics status',
    stockStatusLabel: 'Stock Status:',
    stockStatusPlaceholder: 'Select stock status',
    notOut: 'Not Out',
    out: 'Out',
    purchaseNoLabel: 'Purchase No.:',
    remarkLabel: 'Remark:',
    remarkPlaceholder: 'Remark',
    productNameLabel: 'Product Name',
    agentIdLabel: 'Agent ID',
    agentNameLabel: 'Agent Name',
    sealStatus: 'Seal Status',
    accountStatus: 'Account Status',
    deviceStatus: 'Device Status',
    stockStatus: 'Stock Status',
    deviceActivateTime: 'Device Activate Time',
    accountActivateTime: 'Account Activate Time',
    purchaseNoCol: 'Purchase No.',

    // DeliveryCreation / DeliveryDetail
    agentIdLabelForm: 'Agent ID:',
    agentNameLabelForm: 'Agent Name:',
    warehouseLabel: 'Warehouse:',
    pleaseSelectWarehouse: 'Select warehouse',
    receiverLabel: 'Receiver:',
    receiverPhoneLabel: 'Receiver Phone:',
    provinceCityLabel: 'Province/City/District:',
    receiverAddressLabel: 'Receiver Address:',
    pleaseEnterCampusAddress: 'Enter campus address',
    remarkLabel: 'Remark:',
    pleaseEnterRemark200: 'Enter remark (max 200 chars)',
    selectAddGoods: '+ Select Add Goods',
    addGoods: 'Add Goods',
    operation: 'Operation',
    delete: 'Delete',
    submit: 'Submit',
    cancel: 'Cancel',
    confirm: 'Confirm',
    confirmDelete: 'Confirm to delete?',
    pleaseSelectWarehouseRule: 'Please select warehouse',
    pleaseEnterReceiverRule: 'Enter receiver name',
    phoneRequiredRule: 'Phone number is required',
    pleaseEnterValidPhone: 'Enter valid phone number',
    pleaseSelectProvinceCityRule: 'Select province/city/district',
    pleaseEnterReceiverAddress: 'Enter receiver address',
    deliveryProductName: 'Product Name',
    inventory: 'Inventory',
    warehouseAvailableStock: 'Warehouse Available Stock',
    extractNumLabel: 'Extract Qty',
    ladingNo: 'Lading No.:',
    tidanhao: 'Lading No',
    createBy: 'Creator:',
    sendStatus: 'Send Status:',
    warehouseOrderNo: 'Warehouse Order No',
    goodsInfo: 'Goods Info',
    logisticsInfo: 'Logistics Info',
    dispatchDateLabel: 'Dispatch Date',
    expressCompanyLabel: 'Express Company',
    expressNoLabel: 'Express No.',
    logisticsStatusLabel: 'Logistics Status',
    sendNumLabel: 'Send Qty',
    deleteSuccess: 'Deleted successfully!',
    saveSuccess: 'Saved successfully',
    pleaseSelectWarehouseFirst: 'Please select warehouse first',
    receiverAddressMin8: 'Receiver address must be at least 8 Chinese characters',
    pleaseSelectGoodsFirst: 'Please select goods first',
    extractNumExceedInventory: 'Extract qty cannot exceed warehouse available stock',

    // Barter
    addBarter: 'Add Barter',
    payment: 'Payment',
    modify: 'Modify',
    deliver: 'Deliver',
    more: 'More',
    receiptConfirm: 'Receipt Confirm',
    cancelConfirm: 'Cancel Confirm',
    barterOrderNo: 'Barter Order No.:',
    shipInProductName: 'Ship In Product:',
    shipInSwapNum: 'Ship In Qty:',
    shipOutProductName: 'Ship Out Product:',
    shipOutSwapNum: 'Ship Out Qty:',
    barterPriceDiff: 'Barter Price Diff:',
    cancelBarterTip: 'Confirm to cancel? Once cancelled, this barter application will be void and cannot be restored. You may create a new one if needed.',
    tip: 'Tip',
    paymentDeductionTip: 'This payment will deduct:',
    cashAccount: 'Cash Account',
    goldAccount: 'Gold Account',
    deliveryVoucherAccount: 'Delivery Voucher Account',
    gotIt: 'Got it',
    paySuccessAmount: 'Successfully paid ¥{money}',
    payFailAmount: 'Failed to pay ¥{money}',
    paySuccess: 'Payment Success',
    payFail: 'Payment Failed',
    cancelSuccess: 'Cancelled successfully',
    paymentFail: 'Payment failed',
    paymentSuccess: 'Payment successful',

    // Barter table columns
    barterOrderNoCol: 'Barter Order No.',
    barterStatus: 'Barter Status',
    priceDiffAmount: 'Price Diff Amount',
    prepaidFreight: 'Prepaid Freight',
    paidAmount: 'Paid Amount',
    payStatus: 'Pay Status',
    applyAgentId: 'Apply Agent ID',
    applyAgentName: 'Apply Agent Name',
    shipOutProductNameCol: 'Ship Out Product',
    shipOutSwapNumCol: 'Ship Out Qty',
    productLevel: 'Product Level',
    shipOutSendStatus: 'Ship Out Status',
    swapAgentId: 'Swap Agent ID',
    swapAgentName: 'Swap Agent Name',
    shipInProductNameCol: 'Ship In Product',
    shipInSwapNumCol: 'Ship In Qty',
    shipInSendStatus: 'Ship In Status',
    auditor: 'Auditor',

    // Barter search form
    barterOrderNo: 'Barter Order No.',
    pleaseEnterBarterOrderNo: 'Enter barter order no.',
    barterStatusLabel: 'Barter Status',
    pleaseSelectBarterStatus: 'Select barter status',
    shipOutSendStatusLabel: 'Ship Out Status',
    shipInSendStatusLabel: 'Ship In Status',
    applyWarehouse: 'Apply Warehouse',
    pleaseSelectApplyWarehouse: 'Select apply warehouse',
    swapWarehouse: 'Swap Warehouse',
    pleaseSelectSwapWarehouse: 'Select swap warehouse',
    warehouseOrderNoInput: 'Warehouse Order No.',
    pleaseEnterWarehouseOrderNo: 'Enter warehouse order no.',
    rangeSeparator: 'to',
    payStatusLabel: 'Pay Status',
    pleaseSelectPayStatus: 'Select pay status',
    voucherBonusAccount: 'Voucher Bonus Account',
    deleteSuccess: 'Deleted successfully!',
    childDeviceListExport: 'Child Device List Export',

    // Barter information
    applyInfo: 'Apply Info',
    swapInfo: 'Swap Info',
    applyAgentLabel: 'Apply Agent',
    receiveWarehouse: 'Receive Warehouse',
    pleaseSelectReceiveWarehouse: 'Select receive warehouse',
    provinceCityLabel: 'Province/City/District:',
    receiverLabel: 'Receiver:',
    pleaseEnter: 'Please enter',
    receiverPhoneLabel: 'Receiver Phone:',
    detailAddress: 'Detail Address:',
    pleaseEnterDetailAddress: 'Enter detail address',
    warehouseOrderNoLabel: 'Warehouse Order No',
    shipStatusLabel: 'Ship Status:',
    expressNoLabel: 'Express No.:',
    selectSwapOutProduct: '+ Select Swap Out Product',
    snCodeCol: 'SN Code',
    unitPriceCol: 'Unit Price',
    quantityCol: 'Qty',
    swapOutTotalAmount: 'Swap Out Total:',
    swapAgentLabel: 'Swap Agent:',
    pleaseSelectSwapAgent: 'Select swap agent',
    selectSwapInProduct: '+ Select Swap In Product',
    swapInTotalAmount: 'Swap In Total:',
    selectSwapOutProductTitle: 'Select Swap Out Product',
    swapOutProductModel: 'Swap Out Product Model',
    pleaseSelectProductModel: 'Select product model',
    differentPriceCannotMerge: '**Products with different prices cannot be merged for swap**',
    pleaseEnterSnCode: 'Enter SN code',
    transferPending: 'Pending',
    transferSelected: 'Selected',
    selectSwapInProductTitle: 'Select Swap In Product',
    swapInProductModel: 'Swap In Product Model:',
    productSwapableQty: 'Product Swapable Qty:',
    swapQtyLabel: 'Swap Qty:',
    pleaseEnterQty: 'Enter quantity',
    swapOutProductModelLabel: 'Swap Out Product Model:',
    priceDiffAmountLabel: 'Price Diff Amount:',
    paidAmountLabel: 'Paid Amount:',
    barterOrderNoLabel: 'Barter Order No.:',
    barterStatusLabel: 'Barter Status:',
    createTimeLabel: 'Create Time:',
    createByLabel: 'Creator:',
    remarkLabelBarter: 'Remark:',
    remarkPlaceholder200: 'Enter remark within 200 characters',
    auditRemarkLabelBarter: 'Audit Remark:',
    auditResultLabel: 'Audit Result:',
    agree: 'Agree',
    reject: 'Reject',
    auditOpinionLabel: 'Audit Opinion:',
    auditOpinionPlaceholder: 'Enter audit opinion within 100 characters',
    pleaseSelectAuditResult: 'Select audit result',
    pleaseEnterAuditOpinion: 'Enter audit opinion',
    yuan: 'yuan',
    pleaseEnterReceiverType: 'Enter {type} receiver',
    pleaseEnterReceiverPhoneType: 'Enter {type} receiver phone',
    pleaseSelectProvinceCityType: 'Select {type} province/city/district',
    pleaseEnterDetailAddressType: 'Enter {type} detail address',
    warehouseSameTip: 'Swap in/out warehouses must be the same. For cloud warehouse, use same location!',
    headquarterSwapTip: 'For HQ swap "HQ repurchase product", price diff must be 0',
    pleaseSelectSwapOutFirst: 'Please select swap out product first',
    swapQtyMin1: 'Swap quantity cannot be less than 1',
    swapQtyExceedTotal: 'Swap quantity cannot exceed available in warehouse',
    pleaseFillComplete: 'Please fill in complete info',
    warehouseChangeSwapOutTip: 'Warehouse change will clear all selected swap out products. Continue?',
    warehouseChangeSwapInTip: 'Warehouse change will clear all selected swap in products. Continue?',
    swapAgentChangeTip: 'Swap agent change will clear all selected swap in products. Continue?',
    applyParty: 'Apply Party',
    swapParty: 'Swap Party',
    paramType: 'Parameter Type',
    paramValue: 'Parameter Value',
    condition: 'Condition',
    pleaseSelectProduct: 'Please select product',
    pleaseSelectParamType: 'Please select parameter type',
    productNameCol: 'Product Name',
    mailPayMark: 'Mail Pay Mark',
    productLevelCol: 'Product Level',
    amountCol: 'Amount',
    operationSuccess: 'Operation Success',
    pleaseSelectDeviceToSelected: 'Please select device to selected area!',
    differentModelCannotMerge: 'Different models or prices cannot be merged for exchange',
    pleaseSelectExchangeOut: 'Please select swap out product',
    pleaseSelectExchangeIn: 'Please select swap in product',
    applyShipWarehouse: 'Apply Ship Warehouse',
    swapShipWarehouse: 'Swap Ship Warehouse',
    applyReceiver: 'Apply Receiver',
    swapReceiver: 'Swap Receiver',
    shipOutExpressNo: 'Ship Out Express No.',
    shipInExpressNo: 'Ship In Express No.',
    shipOutProductShip: 'Ship Out Product',
    shipInProductShip: 'Ship In Product',
    pleaseEnterFullExpressNo: 'Please enter complete express no.',
    shipSuccess: 'Shipment Success',
    pleaseEnterProductExpressNo: 'Please enter product express no.',
    shipIn: 'Ship In',
    shipOut: 'Ship Out',
    receiveConfirmTitle: 'Product Receive Confirm',
    receiveConfirmCheck: 'Receive confirm: model, qty, SN code match',
    refuseAccept: 'Refuse:',
    pleaseEnterRefuseReason: 'Enter refuse reason',
    receiveConfirmTip: 'Once confirmed, swap product SN will transfer to swap party and cannot be returned!',
    pleaseCheckVerify: 'Please check verification item!',
    shipInOutExpressNo: 'Product Express No.:',
    shipInOutStatus: 'Product Ship Status:',
    warehouseShipOrderNo: 'Warehouse Ship Order No.:',
    payTitle: 'Payment',
    freightAmountLabel: 'Freight',
    relatedAgent: 'Related Agent',
    goldAccountLabel: 'Gold Account',
    cashAccountLabel: 'Cash Account',
    deliveryVoucherLabel: 'Delivery Voucher',
    accountBalance: 'Account Balance',
    relatedAgentBalance: 'Related Agent Balance',
    availableAmount: 'Available Amount',
    remainingPayAmount: 'Remaining Pay Amount',
    payMethod: 'Pay Method',
    bankTransfer: 'Bank Transfer',
    transferAmount: 'Transfer Amount',
    payTimeLabel: 'Pay Time',
    payTimeRequired: 'Pay time is required',
    pleaseSelectPayTime: 'Select pay time',
    paySerialNo: 'Pay Serial No.',
    pleaseEnterPaySerialNo: 'Enter pay serial no.',
    payVoucher: 'Pay Voucher',
    payVoucherRequired: 'Pay voucher is required',
    payVoucherTip: 'Support jpg/png, max 1080x1920, size under 5MB',
    credentialInstance: 'Voucher Example',
    payRemark: 'Pay Remark',
    pleaseEnterPayRemark: 'Enter pay remark',
    bankAccount: 'Bank Account',
    bankName: 'Bank Name',
    orderCreateTime: 'Order Time',
    buyNumLabel: 'Buy Qty',
    orderAmountLabel: 'Order Amount',
    paidAmountReal: 'Paid Amount',
    freightPlan: 'Freight Plan',
    plan1FreightCollect: 'Plan 1: Freight Collect',
    plan1FreightTip: '(Pay to courier on delivery, amount may vary ~20%)',
    plan2FreightPrepay: 'Plan 2: Freight Prepay',
    plan2FreightTip: '(Original {amount} yuan, pay with order, HQ handles disputes)',
    chargeItem: 'Charge Item',
    unitPrice: 'Unit Price',
    quantity: 'Qty',
    amount: 'Amount',
    discount: 'Discount',
    amountAfterDiscount: 'Amount After Discount',
    freightOrderTip: 'Order qty < 10, default freight collect. Prepay option for discount. Note:',
    freightRule1: '1. Collect discount per JD warehouse agreement, currently 65% off;',
    freightRule2: '2. Prepay optional; if declined, pay courier on delivery per their terms;',
    freightRule3: '3. If order merged and meets free shipping (≥10 units), prepaid freight refunded;',
    payFreightCollect: 'Pay (Freight Collect)',
    payFreightPrepay: 'Pay (Freight Prepay)',
    pleaseDoNotOperateTooFrequently: 'Please do not operate too frequently',
    qrCodeGenerating: 'QR code generating...',
    scanWithAlipay: 'Scan with Alipay',
    scanWithWechat: 'Scan with WeChat',
    qrCodeUrlInvalid: 'QR code URL invalid',
    payAmountYuan: 'Pay {amount} yuan',
    unitTai: ' units',

    // JdSendParamConfig & HeadOfficeShipment
    add: 'Add',
    jdSendParamExport: 'JD Warehouse Shipment Param Config Export',
    jdSend: 'JD Warehouse Shipment',
    printDeliveryOrder: 'Print Delivery Order',
    adjustDispatchType: 'Adjust Dispatch Type',
    adjustDispatchTypeTo: 'Adjust dispatch type to:',
    pleaseSelectDispatchType: 'Select dispatch type',
    confirmCancel: 'Confirm cancel?',
    regionAgentLabel: 'Shipment Region Agent',
    receiverInfo: 'Receiver Info',
    pleaseEnterReceiverInfo: 'Enter receiver info',
    tmallOrderNo: 'Tmall Order No.',
    pleaseEnterTmallOrderNo: 'Enter Tmall order no.',
    confirmBy: 'Confirm By',
    shipRegionAgentId: 'Ship Region Agent ID',
    shipRegionAgentName: 'Ship Region Agent Name',

    // AreaJdSend / AreaConsignment
    saleShipmentExport: 'Sale Shipment Export',
    shipWarehouse: 'Ship Warehouse',
    pleaseSelectShipWarehouse: 'Select ship warehouse',
    jdProductName: 'JD Product Name',
    pleaseEnterJdProductName: 'Enter JD product name',
    waitSendNumCol: 'Wait Send Qty',
    agentWarehouseName: 'Agent Warehouse',
    provinceCity: 'Province/City/District',
    receiverAddress: 'Receiver Address',
    shipWarehouseCol: 'Ship Warehouse',
    relatedOrder: 'Related Order',
    pleaseEnterRelatedOrder: 'Enter related order',
    sendTime: 'Ship Time',
    sentNum: 'Sent Qty',
    logisticsCompany: 'Logistics Company',
    logisticsNo: 'Logistics No.',
    pleaseEnterLogisticsNo: 'Enter logistics no.',
    orderDeliveryStatus: 'Order Delivery Status',
    pleaseSelectOrderDeliveryStatus: 'Select order delivery status',
    shipWarehouseLabel: 'Ship Warehouse',
    transferOrderNo: 'Transfer Order No.',
    dispatchDate: 'Dispatch Date',
    expressCompany: 'Express Company',
    expressNo: 'Express No.',
    logisticsStatus: 'Logistics Status',
    shipStatus: 'Ship Status',
    pleaseSelectShipStatus: 'Select ship status',
    cancelBy: 'Cancel By',
    cancelTime: 'Cancel Time',
    confirmCancelShip: 'Confirm cancel shipment?',
    pleaseEnterTransferOrderNo: 'Enter transfer order no.',
    pleaseEnterShipmentNo: 'Enter shipment no.',
    pleaseSelectDeliveryOrder: 'Please select delivery order',
    generateDeliveryOrderSuccess: 'Delivery order created successfully!',
    confirmFailed: 'Confirm failed',
    adjustDispatchTypeSuccess: 'Dispatch type adjusted successfully!',
    pleaseFillManualAllocationInfo: 'Please fill in complete manual allocation info before saving',
    pleaseSelectPaymentMethod: 'Please select payment method for remaining amount',
    insufficientBalanceRecharge: 'Insufficient balance. Please recharge first.',
    snDuplicateCheck: 'SN code duplicate. Please check and confirm!',
    currentSnExists: 'Current SN code already exists!',
    pleaseEnterDeviceInfo: 'Please enter device info',
    order: 'Tmall Order No.',
    ship: 'Partial Shipment',
    type: 'Agent Type',
    time: 'Account Activation Time',
    danhao: 'Express No.',
    tidanhao: 'Pickup No.',
    device: 'Device SN Code:',
    you: 'Valid',
    already: 'Applied',
    name: 'Sub-agent Name',
    info: 'Receipt Info:',
    chudanhao: 'Cloud Warehouse Outbound Order No.',
    hao: 'Batch No.',
    address: 'Receiver Address',
    shengshang: 'Manufacturer',
    mobile: 'Please enter name/phone number/address',
    queren: 'Receipt Confirm',
    pending: 'Pending',
    purchase: 'Purchase Order',
    num: 'Shipment Quantity',
    dianhua: 'Receiver Phone',
    activate: 'Activated',
    jie: 'Frozen',
    not: 'Not Outbound',
    jidailiqu: 'Sub-agent Region',
    dinghao: 'Subscription Card No.',
    qing: 'Cannot Apply',
    buyTime: 'Purchase Date',
    validTime: 'Valid Date',
    // Head office shipment — agent transfer dispatch order status filter (backend codes)
    headOfficeDispatchOrderStatus6068002: 'Confirmed',
    headOfficeDispatchOrderStatus6068010: 'Shipping',
    headOfficeDispatchOrderStatus6068007: 'Shipped',
    headOfficeDispatchOrderStatus6068009: 'Partially Shipped',
    headOfficeDispatchOrderStatus6068008: 'Receipt Confirmed',
    headOfficeDispatchOrderStatus6068013: 'Rejected, Pending Dispatch',
    headOfficeTransferColOrderQty: 'Order Qty',
    headOfficeTransferColOrderAmount: 'Order Amount',
    headOfficeTransferColShipOrderNo: 'Shipment No.',
    // Area consignment — ship status filter (isDelete: 0 valid / 1 cancelled)
    areaConsignmentShipStatusValid: 'Valid',
    areaConsignmentShipStatusCancelled: 'Cancelled',
  }
}
